// components/landing/sections/LandingFooter.tsx
// Minimal footer with logo, links, and copyright.

import { Box, Divider, Link, Typography, alpha, useTheme } from "@mui/material";

export default function LandingFooter() {
  const theme = useTheme();
  const year = new Date().getFullYear();

  return (
    <Box
      id="contact"
      sx={{
        py: { xs: 4, md: 6 },
        px: 4,
        background: theme.palette.primary.main,
      }}
    >
      <Box
        sx={{
          maxWidth: 1100,
          mx: "auto",
          display: "flex",
          flexDirection: { xs: "column", md: "row" },
          alignItems: { xs: "center", md: "flex-start" },
          justifyContent: "space-between",
          gap: 4,
        }}
      >
        {/* Left: Logo + tagline */}
        <Box sx={{ textAlign: { xs: "center", md: "left" } }}>
          <Box
            component="img"
            src="/brand/inline/athena_tech_white_path.svg"
            alt="Athena Tech"
            sx={{ height: 28, width: "auto", mb: 1, opacity: 0.9 }}
          />
          <Typography variant="body2" sx={{ color: alpha(theme.palette.common.white, 0.55), maxWidth: 320 }}>
            AI-powered healthcare platform designed to streamline complex oncological patient data.
          </Typography>
        </Box>

        {/* Center: Links */}
        <Box
          sx={{
            display: "flex",
            gap: 3,
            flexWrap: "wrap",
            justifyContent: "center",
          }}
        >
          {[
            { label: "Product", href: "#product" },
            { label: "Pricing", href: "#pricing" },
            { label: "Team", href: "/team" },
            { label: "Contact", href: "/contact" },
          ].map((link) => (
            <Link
              key={link.label}
              href={link.href}
              underline="hover"
              sx={{
                color: alpha(theme.palette.common.white, 0.7),
                fontSize: "0.9rem",
                fontWeight: 500,
                "&:hover": { color: theme.palette.common.white },
              }}
            >
              {link.label}
            </Link>
          ))}
        </Box>

        {/* Right: Address + Contact */}
        <Box sx={{ textAlign: { xs: "center", md: "right" } }}>
          <Link
            href="mailto:support@athenatechai.com"
            underline="hover"
            sx={{ color: alpha(theme.palette.common.white, 0.6), fontSize: "0.85rem", display: "block", mb: 0.5, "&:hover": { color: theme.palette.common.white } }}
          >
            support@athenatechai.com
          </Link>
          <Typography variant="caption" sx={{ color: alpha(theme.palette.common.white, 0.45), display: "block" }}>
            Passatge de Ricard Zamora, 1
          </Typography>
          <Typography variant="caption" sx={{ color: alpha(theme.palette.common.white, 0.45), display: "block" }}>
            08017 Barcelona, Spain
          </Typography>
        </Box>
      </Box>

      <Divider sx={{ borderColor: alpha(theme.palette.common.white, 0.1), my: 3, maxWidth: 1100, mx: "auto" }} />

      <Typography
        variant="caption"
        sx={{
          display: "block",
          textAlign: "center",
          color: alpha(theme.palette.common.white, 0.35),
        }}
      >
        &copy; {year} Athena Tech AI S.L. All rights reserved.
      </Typography>
    </Box>
  );
}
